export default {
      id: "info-usage",
      viewBox: "0 0 1365 1024",
      url: __webpack_public_path__ + "static/img/icons.d90c56e0.svg#info",
      toString: function () {
        return this.url;
      }
    }